import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MessageToAliens.css';

export default function MessageToAliens() {
  const navigate = useNavigate();
  const publishDate = 'April 20, 2025';

  return (
    <div className="message-aliens-page">
      <article className="blogpost-container">
        <button className="back-btn" onClick={() => navigate('/blogs')}>
          ←
        </button>

        <header>
          <h1 className="blog-title">Message to Aliens</h1>
          <time className="blog-date" dateTime="2025-04-29">{publishDate}</time>
        </header>

        <section className="blog-section">
          <p>
            If Earth successfully sends a probe to an exoplanet with aliens,
            what would the message be considering there is a limit on the data we can pass?
          </p>
        </section>

        <section className="blog-section">
          <p>
            Useful knowledge is the most important thing we can send.
            Firstly, language. There must be a way to communicate with them.
            Condensing words with visual images would be a way like linking an image of a tree to the word.
            Attaching it all to a drive can be a good idea, but they must know how to use it.
            Therefore, it can be added along with physical engravings of scripts onto the probe
            of how to use the drive and learning the language itself in case they are unable to figure out
            how to operate the drive.
            The drive must be really minimalistic such that it is really flexible to access in any environment.
            So one way is to just keep everything as 8 bits and provide them an ascii table.
            That would take them a while to understand but is totally possible to understand.
          </p>
        </section>

        <section className="blog-section">
          <p>
            In the case of an untimely destruction of the drive there can be some outcomes we might have a sense of.
            As we know it the nearest exoplanet is Proxima Centauri B, 4.22 light years away meaning we wouldn't
            get instantaneous results of the updates of the drive and the probe.
            So if the drive gets received by non-intelligent aliens or aliens that are not advanced enough yet,
            it might get destroyed soon and that can be predicted from the earliest aerial image if there is life already
            or the 1st image itself.
            If the drive gets received by highly intelligent aliens that can be a good thing while being a threat in a way too.
            Maybe if they are looking for another planet to colonize it might not be wise to give our celestial coordinates.
          </p>
        </section>

        <section className="blog-section">
          <p>
            So after schooling the English language, we’d need to send a message that we come here in peace.
            I’d say a good starting message would be “Honored to be your friend. We are Earth”.
            Secondly, communicating with them would be great.
            So a simple message sender in the probe would be helpful.
            Maybe understanding their emotions using computer vision sounds all good
            but sending videos from another planet can be intensive computationally,
            so pit stops along the path to Earth from the exoplanet would make it more efficient.
            Trying to understand their language can be a little tricky in ways.
            What if they talk with their hands like morse code?
            A visual screen can probably be better than physical engravings too if it isn't damaged in the landing.
            That way the message can be customizable according to the behaviour of the aliens.
            So an Earth AI model that has knowledge of humans can be sent as an ambassador.
            It would follow certain protocols and would adjust to the needs of the aliens.
          </p>
        </section>

        <section className="blog-section">
          <p>
            Despite getting their trust we must not send all information such as the conflict of humans with each other,
            or the problem of the steady decline of resources.
            A constitution of the Earth can perhaps help define and make them understand us.
            One real question arises at the fact that what if their 1st message is a threat to us?
            The idea of self destructing the probe can be good, but maybe finding the reasons to do so would help.
            If the aliens were advanced enough they would have definitely interfered with us or ignored us.
            If ignorance is the case then the threat is less.
            Maybe they haven't reached the stage of interfering yet and the message can be the start of it.
            If they have similar knowledge as us, it wouldn’t take them long to discover our celestial coordinates from the probe,
            or even worse find out the way to travel to us.
            What if they perceive us as a threat before decoding our message?
            If they were likely to start a war on us, one way to do so is to send explosives to Earth.
            So therefore 1st impressions would matter enough to end a war before it even starts.
            In case of them having the inability of emotions, the model we send should be able to detect the way they communicate with each other.
            One reason for them to not add us on their hit list is to do a negotiation of trade of knowledge.
            We’ll give our information if they give theirs.
          </p>
        </section>

        <section className="blog-section">
          <p>
            In the end the likelihood of aliens is either really unlikely or very likely.
            Maybe they haven't met us for a reason of something way bigger than us.
          </p>
        </section>

      </article>
    </div>
  );
}
